import React from 'react'

import s from './styles.module.scss'

import { Icon } from '../../../../atoms'

function Vote({
  voteCount,
  icon,
}: {
  voteCount: number
  icon: React.ReactNode
}) {
  return (
    <p className={s.uservote}>
      {icon}
      <span>{voteCount}</span>
    </p>
  )
}

export default function ProposalVoteCounters({
  negativeVoteCount = 0,
  positiveVoteCount = 0,
}: {
  negativeVoteCount?: number
  positiveVoteCount?: number
}) {
  if (negativeVoteCount + positiveVoteCount === 0) {
    return null
  }

  return (
    <div className={s.userVotesWrapper}>
      <Vote
        voteCount={positiveVoteCount}
        icon={<Icon name='thumb-up' size={18} color='#0CBC88' />}
      />
      <Vote
        voteCount={negativeVoteCount}
        icon={<Icon name='thumb-down' size={18} color='#F18D8D' />}
      />
    </div>
  )
}
